// src/config.js
const config = {
//baseUrl: 'http://localhost:8080', 
baseUrl: 'https://joyaura-backend.onrender.com', 
};
//test november branch
export default config;